import React, { useCallback, useEffect, useMemo } from 'react'
import { useErrorHandling } from 'context/errorHandling'
import { getCustomFieldValue } from 'services/CustomFieldService'
import { useTranslation } from 'react-i18next'
import CustomFieldType from 'constants/CustomFieldTypes'

export function CustomField ({ definition, entityId, value, onValueChanged, renderField }) {
  const {
    id: definitionId,
    type,
    defaultValue: definitionDefaultValue,
    selectOptions,
    isEnabled
  } = definition

  const { handleError } = useErrorHandling()
  const { i18n } = useTranslation()

  const isSelectType = type === CustomFieldType.Select
  const defaultValue = useMemo(() =>
      isSelectType ? selectOptions.find(options => options.isDefault)?.id : definitionDefaultValue
    , [isSelectType, selectOptions, definitionDefaultValue])

  useEffect(() => {
      if (entityId) {
        getCustomFieldValue(definitionId, entityId)
          .then(result => {
            const fieldValue = isSelectType ? result.valueId : result.value
            if (fieldValue !== undefined) onValueChanged(fieldValue)
            else if (result.undefined && isEnabled) onValueChanged(defaultValue)
          })
          .catch(handleError)
      } else if (isEnabled) {
        onValueChanged(defaultValue)
      }
    }, [isSelectType, definitionId, defaultValue, entityId, onValueChanged, isEnabled, handleError]
  )

  const getTranslation = useCallback((translations) => {
    return translations[i18n.language]
  }, [i18n.language])

  const isFieldToShow = isEnabled || value !== undefined

  return isFieldToShow ? renderField(getTranslation) : <></>
}
